import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderGoogleSheetCommon = {
  key: 'googleSheet',
  authentication: ProviderAuthenticationCommon.Oauth2({
    key: 'googleSheet',
    authUrl: 'https://accounts.google.com/o/oauth2/auth',
    tokenUrl: 'https://oauth2.googleapis.com/token',
    scopes: [
      'https://www.googleapis.com/auth/userinfo.profile',
      'https://www.googleapis.com/auth/spreadsheets',
      'https://www.googleapis.com/auth/drive.readonly',
      'https://www.googleapis.com/auth/drive',
    ],
  }),
}

export type ProviderGoogleSheetAccountType = unknown
